/**
 * Generated by orval 🍺
 * Do not edit manually.
 * STBportalen
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  KontrollCreateDto
} from '../../model';

import { customInstance } from '../../../mutator/custom-instance';
import type { ErrorType , BodyType } from '../../../mutator/custom-instance';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const postApiProjectsProjectIdPreworkcontrol = (
    projectId: number,
    kontrollCreateDto?: BodyType<KontrollCreateDto>,
 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/projects/${projectId}/preworkcontrol`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: kontrollCreateDto, signal
    },
      );
    }




export const getPostApiProjectsProjectIdPreworkcontrolMutationKey = () => ['postApiProjectsProjectIdPreworkcontrol'] as const;

export const getPostApiProjectsProjectIdPreworkcontrolMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiProjectsProjectIdPreworkcontrol>>, TError,PostApiProjectsProjectIdPreworkcontrolMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiProjectsProjectIdPreworkcontrol>>, TError,PostApiProjectsProjectIdPreworkcontrolMutationVariables, TContext> => {

const mutationKey = getPostApiProjectsProjectIdPreworkcontrolMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiProjectsProjectIdPreworkcontrol>>, PostApiProjectsProjectIdPreworkcontrolMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  postApiProjectsProjectIdPreworkcontrol(projectId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiProjectsProjectIdPreworkcontrolMutationResult = NonNullable<Awaited<ReturnType<typeof postApiProjectsProjectIdPreworkcontrol>>>
    export type PostApiProjectsProjectIdPreworkcontrolMutationBody = BodyType<KontrollCreateDto> | undefined
    export type PostApiProjectsProjectIdPreworkcontrolMutationError = ErrorType<unknown>
    export type PostApiProjectsProjectIdPreworkcontrolMutationVariables = {projectId: number;data?: BodyType<KontrollCreateDto>}

    export const usePostApiProjectsProjectIdPreworkcontrol = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiProjectsProjectIdPreworkcontrol>>, TError,PostApiProjectsProjectIdPreworkcontrolMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiProjectsProjectIdPreworkcontrol>>,
        TError,
        PostApiProjectsProjectIdPreworkcontrolMutationVariables,
        TContext
      > => {
      return useMutation(getPostApiProjectsProjectIdPreworkcontrolMutationOptions(options), queryClient);
    }
    export const getApiProjectsProjectIdPreworkcontrol = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<KontrollCreateDto>(
      {url: `/api/projects/${projectId}/preworkcontrol`, method: 'GET', signal
    },
      );
    }




export const getGetApiProjectsProjectIdPreworkcontrolQueryKey = (projectId: number,) => {
    return [
    `/api/projects/${projectId}/preworkcontrol`
    ] as const;
    }


export const getGetApiProjectsProjectIdPreworkcontrolQueryOptions = <TData = Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrol>>, TError = ErrorType<unknown>>(projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrol>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiProjectsProjectIdPreworkcontrolQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrol>>> = ({ signal }) => getApiProjectsProjectIdPreworkcontrol(projectId, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrol>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiProjectsProjectIdPreworkcontrolQueryResult = NonNullable<Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrol>>>
export type GetApiProjectsProjectIdPreworkcontrolQueryError = ErrorType<unknown>


export function useGetApiProjectsProjectIdPreworkcontrol<TData = Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrol>>, TError = ErrorType<unknown>>(
 projectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrol>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrol>>,
          TError,
          Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrol>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProjectsProjectIdPreworkcontrol<TData = Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrol>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrol>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrol>>,
          TError,
          Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrol>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProjectsProjectIdPreworkcontrol<TData = Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrol>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrol>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiProjectsProjectIdPreworkcontrol<TData = Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrol>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrol>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiProjectsProjectIdPreworkcontrolQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiProjectsProjectIdPreworkcontrol = (
    projectId: number,
    kontrollCreateDto?: BodyType<KontrollCreateDto>,
 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/projects/${projectId}/preworkcontrol`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: kontrollCreateDto, signal
    },
      );
    }




export const getPutApiProjectsProjectIdPreworkcontrolMutationKey = () => ['putApiProjectsProjectIdPreworkcontrol'] as const;

export const getPutApiProjectsProjectIdPreworkcontrolMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiProjectsProjectIdPreworkcontrol>>, TError,PutApiProjectsProjectIdPreworkcontrolMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiProjectsProjectIdPreworkcontrol>>, TError,PutApiProjectsProjectIdPreworkcontrolMutationVariables, TContext> => {

const mutationKey = getPutApiProjectsProjectIdPreworkcontrolMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiProjectsProjectIdPreworkcontrol>>, PutApiProjectsProjectIdPreworkcontrolMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  putApiProjectsProjectIdPreworkcontrol(projectId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiProjectsProjectIdPreworkcontrolMutationResult = NonNullable<Awaited<ReturnType<typeof putApiProjectsProjectIdPreworkcontrol>>>
    export type PutApiProjectsProjectIdPreworkcontrolMutationBody = BodyType<KontrollCreateDto> | undefined
    export type PutApiProjectsProjectIdPreworkcontrolMutationError = ErrorType<unknown>
    export type PutApiProjectsProjectIdPreworkcontrolMutationVariables = {projectId: number;data?: BodyType<KontrollCreateDto>}

    export const usePutApiProjectsProjectIdPreworkcontrol = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiProjectsProjectIdPreworkcontrol>>, TError,PutApiProjectsProjectIdPreworkcontrolMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiProjectsProjectIdPreworkcontrol>>,
        TError,
        PutApiProjectsProjectIdPreworkcontrolMutationVariables,
        TContext
      > => {
      return useMutation(getPutApiProjectsProjectIdPreworkcontrolMutationOptions(options), queryClient);
    }
    export const postApiProjectsProjectIdPreworkcontrolSign = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/projects/${projectId}/preworkcontrol/sign`, method: 'POST', signal
    },
      );
    }




export const getPostApiProjectsProjectIdPreworkcontrolSignMutationKey = () => ['postApiProjectsProjectIdPreworkcontrolSign'] as const;

export const getPostApiProjectsProjectIdPreworkcontrolSignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiProjectsProjectIdPreworkcontrolSign>>, TError,PostApiProjectsProjectIdPreworkcontrolSignMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiProjectsProjectIdPreworkcontrolSign>>, TError,PostApiProjectsProjectIdPreworkcontrolSignMutationVariables, TContext> => {

const mutationKey = getPostApiProjectsProjectIdPreworkcontrolSignMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiProjectsProjectIdPreworkcontrolSign>>, PostApiProjectsProjectIdPreworkcontrolSignMutationVariables> = (props) => {
          const {projectId} = props ?? {};

          return  postApiProjectsProjectIdPreworkcontrolSign(projectId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiProjectsProjectIdPreworkcontrolSignMutationResult = NonNullable<Awaited<ReturnType<typeof postApiProjectsProjectIdPreworkcontrolSign>>>

    export type PostApiProjectsProjectIdPreworkcontrolSignMutationError = ErrorType<unknown>
    export type PostApiProjectsProjectIdPreworkcontrolSignMutationVariables = {projectId: number}

    export const usePostApiProjectsProjectIdPreworkcontrolSign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiProjectsProjectIdPreworkcontrolSign>>, TError,PostApiProjectsProjectIdPreworkcontrolSignMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiProjectsProjectIdPreworkcontrolSign>>,
        TError,
        PostApiProjectsProjectIdPreworkcontrolSignMutationVariables,
        TContext
      > => {
      return useMutation(getPostApiProjectsProjectIdPreworkcontrolSignMutationOptions(options), queryClient);
    }
    export const getApiProjectsProjectIdPreworkcontrolPdf = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/projects/${projectId}/preworkcontrol/pdf`, method: 'GET', signal
    },
      );
    }




export const getGetApiProjectsProjectIdPreworkcontrolPdfQueryKey = (projectId: number,) => {
    return [
    `/api/projects/${projectId}/preworkcontrol/pdf`
    ] as const;
    }


export const getGetApiProjectsProjectIdPreworkcontrolPdfQueryOptions = <TData = Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrolPdf>>, TError = ErrorType<unknown>>(projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrolPdf>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiProjectsProjectIdPreworkcontrolPdfQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrolPdf>>> = ({ signal }) => getApiProjectsProjectIdPreworkcontrolPdf(projectId, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrolPdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiProjectsProjectIdPreworkcontrolPdfQueryResult = NonNullable<Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrolPdf>>>
export type GetApiProjectsProjectIdPreworkcontrolPdfQueryError = ErrorType<unknown>


export function useGetApiProjectsProjectIdPreworkcontrolPdf<TData = Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrolPdf>>, TError = ErrorType<unknown>>(
 projectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrolPdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrolPdf>>,
          TError,
          Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrolPdf>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProjectsProjectIdPreworkcontrolPdf<TData = Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrolPdf>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrolPdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrolPdf>>,
          TError,
          Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrolPdf>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProjectsProjectIdPreworkcontrolPdf<TData = Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrolPdf>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrolPdf>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiProjectsProjectIdPreworkcontrolPdf<TData = Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrolPdf>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsProjectIdPreworkcontrolPdf>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiProjectsProjectIdPreworkcontrolPdfQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






